import base from './base';
import dark from './dark';

export const DEFAULT_THEME = localStorage.getItem('DEFAULT_THEME') || 'base';

export const themes = {
  base,
  dark,
};
